module.exports = __webpack_public_path__ + "img/CombatArmorMark2.c001eefd.gif";